import { useEffect, useRef } from "react";

/**
 * Debounced persist while the user edits, plus a final write on unmount
 * (step change via nav, Back, or leaving the page).
 */
export function useAutosave(value, save, delay = 400) {
  const saveRef = useRef(save);
  const valueRef = useRef(value);
  const skipFirst = useRef(true);

  saveRef.current = save;
  valueRef.current = value;

  useEffect(() => {
    if (skipFirst.current) {
      skipFirst.current = false;
      return undefined;
    }
    const timer = window.setTimeout(() => {
      saveRef.current(valueRef.current);
    }, delay);
    return () => window.clearTimeout(timer);
  }, [value, delay]);

  useEffect(() => {
    return () => {
      saveRef.current(valueRef.current);
    };
  }, []);
}
